import { Text } from "@/components";
import { cn } from "@/lib/utils";

// Halloween finish marker: dim until the staffer crosses the line, then lit.
export const FinishPumpkin = ({ isLit }: { isLit: boolean }) => (
  <Text
    className={cn(
      "text-[24px] leading-none transition-[filter,opacity] duration-700",
      isLit ? "leaderboard-pumpkin-flicker" : "opacity-50 grayscale",
    )}
  >
    🎃
  </Text>
);
